import React from 'react';
import { pdfFiles } from '../../body/Pdf';
import { VideoAndShowPDFAfter } from '../../body/VideoSlide';

const HybridIntroduction = () => {
  return (
    <div className='text-left p-4 space-y-6'>
      <VideoAndShowPDFAfter vidSrc={1195764250} />
    </div>
  );
};

export default HybridIntroduction;
